var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{class:{ 'black--text': _vm.isTextBlack },attrs:{"color":_vm.color,"small":"","disabled":_vm.disabled},on:_vm._d({},[_vm.click,function($event){return _vm.$emit('click')}])},[_vm._v(" "+_vm._s(_vm.$t(`status.${_vm.getRole}.${_vm.status}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }